import { booleanAttribute, Component, input, inject, ChangeDetectionStrategy } from '@angular/core';
import type { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { Store } from '@ngrx/store';

import {
  DividerComponent,
  HeadingComponent,
  ProtectedControlDirective,
} from '@core/user-interface-legacy';

import { InterviewBaseBoxComponent } from '../interview-base-box/interview-base-box.component';
import { InterviewButtonSelectComponent } from '../interview-button-select/interview-button-select.component';

@Component({
  selector: 'rt-interview-scorecard',
  templateUrl: 'interview-scorecard.component.html',
  styleUrls: ['./interview-scorecard.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    ProtectedControlDirective,
    HeadingComponent,
    DividerComponent,
    InterviewBaseBoxComponent,
    InterviewButtonSelectComponent,
  ],
})
export class InterviewScorecardComponent {
  private readonly store = inject(Store);

  public readonly questionForm = input<UntypedFormGroup>(undefined!);
  public readonly formSubmissionAttempt = input<boolean>(false);
  public hasProtectedControls = input.required<boolean, boolean | string>({
    transform: booleanAttribute,
  });

  public getOptionsControls() {
    return <UntypedFormControl[]>(<UntypedFormArray>this.questionForm().get('options')).controls;
  }

  public trackByOption(index: number, option: UntypedFormControl): number {
    return option.value.title;
  }
}
